import "./index.css";

// react
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { SnackbarProvider } from "notistack";

// components
import Router from "./components/Router";

// context
import RoleContext from "components/RoleContext";

ReactDOM.render(
	<React.StrictMode>
		<SnackbarProvider
			maxSnack={3}
			autoHideDuration={1500}
			anchorOrigin={{
				vertical: "top",
				horizontal: "center",
			}}
		>
			<RoleContext>
				<BrowserRouter>
					<Router />
				</BrowserRouter>
			</RoleContext>
		</SnackbarProvider>
	</React.StrictMode>,
	document.getElementById("root")
);
